import { Tooltip } from '@material-ui/core';
import React from 'react';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function FieldIdCommon({ fieldId }) {
    useTranslationSubscription();
    if (!fieldId.includes('field_')) {
        return null;
    }

    return (
        <div className="lstCreateForm lstCreateForm--changePt">
            <span style={{ fontWeight: '400', color: '#2E3138' }}>
                {trI18n('CM-LABEL-FIELD-ID')}
            </span>{' '}
            :
            <Tooltip title={fieldId} arrow placement="top">
                <span
                    className="id-detail-ticket-copy"
                    onClick={async () => {
                        navigator.clipboard
                            .writeText(fieldId)
                            .then(() => {})
                            .catch(err => {});
                    }}
                >
                    <img src="/assets/image/icon-copy.svg" alt="" />
                </span>
            </Tooltip>
            <span>{fieldId}</span>
        </div>
    );
}
